module.exports = __webpack_public_path__ + "static/media/banner-adocao.d06513e7.png";